module.exports = __webpack_public_path__ + "img/no-history.72790637.png";